(function () {
    const cardCarousels = document.querySelectorAll('.card-carousel__list')
    if (cardCarousels.length) cardCarousels.forEach(async c => {
        const {CardCarousel} = await import(/* webpackChunkName: "cardCarousel" */'./card-carousel')
        new CardCarousel(c)
    })

    const navCarousels = document.querySelectorAll('.header-nav-carousel__list')
    if (navCarousels) navCarousels.forEach( async s => {
        const {HeaderNavCarousel} = await import(/* webpackChunkName: "headerNavCarousel" */'./header-nav-carousel')
        new HeaderNavCarousel(s)
    })

    const fullWidthCarousels = document.querySelectorAll('.fullwidth-carousel')
    if (fullWidthCarousels.length) fullWidthCarousels.forEach(async c => {
        const {FullwidthCarousel} = await import(/* webpackChunkName: "fullWidthCarousel" */'./fullwidth-carousel')
        new FullwidthCarousel(c)
    })
})()